import React, {Component} from "react";

class League extends Component {

	render() {
		const {league, children} = this.props;
		return (
			<div key={`live-league-${league.id}`}>
				<div className="thead">
					<div className="tr">
						<div className="th time"></div>
						<div className="th players">{league.name}</div>
						<div className="th score"></div>
						<div className="th service"></div>
					</div>
				</div>

				{children}
			</div>
		);
	}
}

export default League;


// WEBPACK FOOTER //
// ./src/app/pages/Result/Line/modules/League.js